import { ColDef } from "ag-grid-community";
import { useMemo } from "react";
import { useRecoilValue } from "recoil";
import { formInEditModeState, useMsRow, mobilityStoresState } from "../state";
import { SelectAllHeader } from "../utils";
import { useTranslation } from "react-i18next";
import Checkbox from "@mui/material/Checkbox";

function TableCheckbox(props: any) {
    const row = useMsRow(props.data.id);

    return (
        <Checkbox
            defaultChecked
            onChange={(evt) => props.setValue(evt.target.checked)}
            checked={!!row?._select}
        />
    )
}

export default function useMsTableColumns() {
    const { t } = useTranslation(['network', 'translation']);
    const formInEditMode = useRecoilValue(formInEditModeState);

    return useMemo<ColDef[]>(() => [
        {
            field: 'name',
            headerName: t("msHoliday.fields.msName"),
            flex: 1,
            minWidth: 150,
            editable: formInEditMode,
            sortable: true,
        },
        {
            field: 'nation',
            headerName: t("msHoliday.fields.nation"),
            flex: 1,
            minWidth: 150,
            editable: formInEditMode,
        },
        {
            field: 'region',
            headerName: t("msHoliday.fields.region"),
            flex: 1,
            minWidth: 150,
            editable: formInEditMode,
            sortable: true,
        },
        {
            field: 'city',
            headerName: t("msHoliday.fields.city"),
            flex: 1,
            minWidth: 150,
            editable: formInEditMode,
            sortable: true,
        },
        {
            field: 'type',
            headerName: t("msHoliday.fields.type"),
            flex: 1,
            minWidth: 150,
            editable: formInEditMode,
            sortable: true,
        },
        {
            field: 'cluster',
            headerName: t("msHoliday.fields.cluster"),
            flex: 1,
            minWidth: 150,
            editable: formInEditMode,
            sortable: true,
        },
        {
            field: '_select',
            headerName: t("msHoliday.fields.selectToAssociate"),
            pinned: 'right',
            minWidth: 180,
            editable: false,
            headerComponent: SelectAllHeader,
            headerComponentParams: {
                displayName: t("msHoliday.fields.selectToAssociate"),
                recoilState: mobilityStoresState
            },
            cellRenderer: (props: any) => <TableCheckbox {...props} />,
        },
    ], [t, formInEditMode])
}